// extracted by mini-css-extract-plugin
export default {"container":"UpdatesView_container__KTHeV","headerCard":"UpdatesView_headerCard__6pr80"};